import { useRoutes, Navigate } from 'react-router';

import { useAppSelector } from '@/hooks/redux';
import Layout from '@/layout';
import Login from '@/views/auth/login/Login';
import LoginForm from '@/views/auth/login/LoginForm';
import RecoverForm from '@/views/auth/login/RecoverForm';
import Logout from '@/views/auth/logout/Logout';
import CreatorGroupsDetail from '@/views/creatorGroups/detail';
import CreatorGroupsList from '@/views/creatorGroups/list';
import CreatorItemsList from '@/views/creators/detail';
import CreatorsList from '@/views/creators/list';
import EvaluationDetails from '@/views/evaluations/detail';
import EvaluationsList from '@/views/evaluations/list';
import Keywords from '@/views/keywordGroups/detail';
import KeywordGroups from '@/views/keywordGroups/list';
import NotFound from '@/views/misc/notFound/index';
import ReleaseNotes from '@/views/misc/releaseNotes';
import PostDetails from '@/views/posts/details';
import Sandbox from '@/views/sandbox';

import { currentUser } from './store/userSlice';
import CreatorPost from './views/creators/detail/post';
import WorkspaceDashboard from './views/dashboard';
import CreateEvaluation from './views/evaluations/create';
import EditEvaluation from './views/evaluations/edit';
import EvaluationStatistics from './views/evaluations/statistics';
import ViolationDetails from './views/violations/detail';
import ViolationsList from './views/violations/list';

const routes = (isLoggedIn) => [
  {
    path: '/',
    element: isLoggedIn ? <Layout /> : <Navigate to="/auth/login" />,
    children: [
      {
        path: 'workspace/:workspaceId',
        children: [
          { index: true, element: <Navigate to="evaluations" /> },
          {
            path: 'evaluations',
            children: [
              { index: true, element: <EvaluationsList /> },
              { path: 'create', element: <CreateEvaluation /> },
              { path: 'edit/:evaluationId', element: <EditEvaluation /> },
              {
                path: ':evaluationId',
                children: [
                  { index: true, element: <EvaluationDetails /> },
                  { path: 'post/:postId', element: <PostDetails /> },
                  { path: 'statistics', element: <EvaluationStatistics /> }
                ]
              }
            ]
          },
          {
            path: 'violations',
            children: [
              { index: true, element: <ViolationsList /> },
              {
                path: ':postId',
                element: <ViolationDetails />
              }
            ]
          },
          {
            path: 'creators',
            children: [
              { index: true, element: <CreatorsList /> },
              {
                path: ':id',
                children: [
                  { index: true, element: <CreatorItemsList /> },
                  { path: 'post/:postId', element: <CreatorPost /> }
                ]
              }
            ]
          },
          {
            path: 'creator-groups',
            children: [
              { index: true, element: <CreatorGroupsList /> },
              { path: ':id', element: <CreatorGroupsDetail /> }
            ]
          },
          {
            path: 'keyword-groups',
            children: [
              { index: true, element: <KeywordGroups /> },
              { path: ':id', element: <Keywords /> }
            ]
          },
          {
            path: 'dashboard',
            children: [{ index: true, element: <WorkspaceDashboard /> }]
          },
          {
            path: 'release-notes',
            element: <ReleaseNotes />
          },
          {
            path: 'sandbox',
            element: <Sandbox />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      }
    ]
  },
  {
    path: '/auth',
    element: <Login />,
    children: [
      { index: true, element: <Navigate to="/auth/login" /> },
      {
        path: 'login',
        element: isLoggedIn ? <Navigate to="/" /> : <LoginForm />
      },
      {
        path: 'recover',
        element: isLoggedIn ? <Navigate to="/" /> : <RecoverForm />
      },
      {
        path: 'logout',
        element: !isLoggedIn ? <Navigate to="/" /> : <Logout />
      }
    ]
  },
  {
    path: '*',
    element: isLoggedIn ? <NotFound /> : <Navigate to="/auth/login" />
  }
];

const Router = () => useRoutes(routes(!!useAppSelector(currentUser)));

export default Router;
